import { render, staticRenderFns } from "./RespostaPagamento.vue?vue&type=template&id=7d3e93d6&"
import script from "./RespostaPagamento.vue?vue&type=script&lang=js&"
export * from "./RespostaPagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports